import styles from "./style.module.scss";
import TopImage from "src/assets/faq_top_image.jpg";

export const TopSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.backgroundImg}>
        <img src={TopImage} alt="Faq" />
        <div className={styles.titleBox}>
          <h1>FAQ</h1>
          <p>よくあるご質問</p>
        </div>
      </div>
    </section>
  );
};
